import React, { useState, useEffect } from 'react';
import '../styles.css'
import './Historia.css'

function Historia() {
  const [tabHist , setTabHist] = useState(null);

  useEffect(() => {
    const fetchHist = async() => {
      const spreadsheetID =  process.env.REACT_APP_SCHEDULE_SPREADSHEET_ID;
      const sheetNameHist = 'História';
      const urlHist = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json&sheet=${sheetNameHist}`;
      
      try {
        const response = await fetch(urlHist)
        .then(res => res.text())
        .then(text => JSON.parse(text.slice(47,-2)))
        setTabHist(response.table.rows[1].c.map(elem => elem && elem.v))

      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      } 
    };
    fetchHist();
  }, []);

  return (
    <>
      {
        <>
          <MobileContent text={tabHist}/>
          <DesktopContent text={tabHist}/>
        </>
      }
    </>
  )

}

export default Historia
              

function DesktopContent({text}) {
 
    return (
      <div className = 'dskt-content'>
        <h1 className='title'>
          <span>História </span>
        </h1>
        {text ? <>
          <section className='history-section'>
            <div className='conteudo-texto'> {text[0]}  </div>
            <img src='../maracaju_04.jpg' alt='' className='conteudo-foto'/>
          </section>
          <section className='history-section'>
            <img src='../maracaju_05.jpg' alt='' className='conteudo-foto'/>
            <div className='conteudo-texto'> {text[1]}  </div>
          </section></> : <></>}
      </div>
    )
  
}

function MobileContent({text}){
  if(text){
    return (
      <div className = 'mbl-content'>
        <h1 className='title'>
          <span>História </span>
        </h1>
        <section className='history-section'>
          <div className='conteudo-texto'> {text[0]}  </div>
          <img src='../maracaju_04.jpg' alt='' className='conteudo-foto'/>
        </section>
        <section className='history-section'>
          <div className='conteudo-texto'> {text[1]}  </div>
          <img src='../maracaju_05.jpg' alt='' className='conteudo-foto'/>
        </section>
      </div>
    )
  }
}